import React, { useState, useEffect } from "react";
import Modal from "../../../../components/Modal";

/**
 * Per-document deficiency modal.
 * Pre-fills existing reason if already saved, allows update.
 *
 * Props:
 *  isOpen         - bool
 *  docName        - string
 *  existingReason - string (pre-fill if editing)
 *  onClose        - fn
 *  onSubmit       - fn(reason: string)
 */
const DocDeficiencyModal = ({
  isOpen,
  docName,
  existingReason,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setReason(existingReason || "");
      setError("");
    }
  }, [isOpen, existingReason]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Reason is required.");
      return;
    }
    onSubmit(reason.trim());
    setReason("");
    setError("");
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Document Deficiency"
      size="small"
    >
      <div className="doc-deficiency-modal">
        <div className="doc-deficiency-modal__doc-tag">
          <span className="doc-deficiency-modal__doc-icon">📄</span>
          <span className="doc-deficiency-modal__doc-name">{docName}</span>
          {existingReason && (
            <span className="doc-deficiency-modal__badge">Editing</span>
          )}
        </div>

        {existingReason && (
          <div className="doc-deficiency-modal__prev">
            <span className="doc-deficiency-modal__prev-label">
              Previous reason:
            </span>
            <span className="doc-deficiency-modal__prev-text">
              {existingReason}
            </span>
          </div>
        )}

        <label
          className="doc-deficiency-modal__label"
          htmlFor="doc-deficiency-reason"
        >
          {existingReason ? "Update reason" : "Deficiency reason"}
          <span className="required-mark"> *</span>
        </label>
        <textarea
          id="doc-deficiency-reason"
          className={`doc-deficiency-modal__textarea${error ? " input-error" : ""}`}
          rows={4}
          placeholder="Please type here your deficiency..."
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError("");
          }}
        />
        {error && <span className="input-error-msg">{error}</span>}

        <div className="doc-deficiency-modal__actions">
          <button type="button" className="btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-submit-reject"
            onClick={handleSubmit}
          >
            {existingReason ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DocDeficiencyModal;
